import en from './locales/en.json';
import zhHK from './locales/zh-HK.json';

export const defaultNS = 'translation' as const;
export const resources = { en: { translation: en }, 'zh-HK': { translation: zhHK } };
